import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router';
import Questions from '../views/QuestionsView/questionContainter';
import DashboardView from '../views/DashboardViews/dashBoardView';
import CuriositiesView from '../views/DashboardViews/curiositiesView';
import ProfileView from '../views/UserViews/profileView';
import ShareView from '../views/UserViews/shareView';
import ResearchView from '../views/ResearchView/researchView';
import UserData from '../views/AuthViews/userDataView';
import Ranking from '../views/rankingView/ranking';
import Interaction from '../views/InteractionViews/interactionContainer';
import CourseSelectView from '../views/courseSelectView';
import ForceUpdate from '../views/forceUpdateView';
import NotificationsView from '../views/NotificationsViews/notificationsView';
import ModalBox from '../views/components/modalBox';
import RestartModalConfirmation from '../views/components/restartModalConfirmation';

import SimpleModal from '../views/simpleModalView/simpleModal';
import MissionTestView from '../views/missionTestView';
import EnemBrowserView from '../views/EnemView/enemBrowserView';

class PrivateRoutes extends Component {
    render () {
        if (!UserHaveData(this.props.userFromAuth, this.props.userFromUser)) {
            // User can only go to UserData if don't have data
            return (
                // DON'T RETURN ANY OTHER ROUTE HERE
                <div>
                    <Route path='/'>
                        <Route exact path='/' component={UserData} />
                    </Route>
                </div>
            );
        } else {
            // All the other routes
            return (
                <div>
                    <ModalBox />
                    <RestartModalConfirmation />
                    <SimpleModal />
                    <Route exact path='/' component={DashboardView} />
                    <Route path='/enem' component={EnemBrowserView} />
                    <Route exact path='/courseSelection/:level' component={CourseSelectView} />
                    <Route exact path='/curiosities' component={CuriositiesView} />
                    <Route exact path='/questions' component={Questions} />
                    <Route exact path='/user' component={ProfileView} />
                    <Route exact path='/research' component={ResearchView} />
                    <Route exact path='/user/:id' component={ProfileView} />
                    <Route path='/ranking' component={Ranking} />
                    <Route path='/interaction' component={Interaction} />
                    <Route path='/selectLevel' component={ForceUpdate} />
                    <Route path='/share' component={ShareView} />
                    <Route path='/notifications/' component={NotificationsView} />
                    <Route path='/missiontest' component={MissionTestView} />
                </div>
            );
        }
    }
}

const UserHaveData = (userAuth, user) => {
    return (userAuth.data && userAuth.data.city !== undefined) || (user.data && user.data.city !== undefined);
};

const mapStateToProps = ({auth, user}) => {
    const userFromAuth = auth.user;
    const userFromUser = user.user;
    return {userFromAuth, userFromUser};
};

export default withRouter(connect(mapStateToProps, {})(PrivateRoutes));



// WEBPACK FOOTER //
// ./src/routes/privateRoutes.js